import CryptoJS from "crypto-js";

const SECRET_KEY = process.env.REACT_APP_AES_SECRET || "your_fallback_key_here";

export const encryptData = (value) => {
  if (!value) return "";
  //return CryptoJS.AES.encrypt(String(value), SECRET_KEY).toString();

  const cryptocharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const base64 = btoa(value); // Encode input to Base64
  const buffer = base64.split('');

  const encrypted = buffer.map((char, i) => {
    const index = cryptocharacters.indexOf(char);
    if (index === -1) return char; // Ignore padding (=) or unknown chars

    const shiftChar = SECRET_KEY[i % SECRET_KEY.length];
    const shift = cryptocharacters.indexOf(shiftChar);
    const newIndex = (index + shift) % cryptocharacters.length;

    return cryptocharacters[newIndex];
  });

  return encrypted.join('');
};
